module.exports = __webpack_public_path__ + "img/Vector.6e143a95.svg";